import { EMPTY_ARRAY, IApplicationState } from '../../../../types/types';
import {TBoardId} from '../../../../types/types';

export const getSelectedCards = (
    state: IApplicationState,
    boardId: TBoardId
): number[] => {
    return state.clickManager[boardId] ? state.clickManager[boardId].selectedCardIds : EMPTY_ARRAY;
};
